import { v4 as uuid } from 'uuid';

const LoaderDetailsTabs = () => {
  const tabsList = [1, 2, 3, 4, 5];

  return (
    <div className="OrderDetailsTabs">
      {tabsList &&
        tabsList.length > 0 &&
        tabsList.map(() => {
          return (
            <div key={uuid()} className={`orderDetailsTab animationLoader`}>
              <div className="tabName" />
            </div>
          );
        })}
    </div>
  );
};
export default LoaderDetailsTabs;
